import { render } from "./AddBranch.vue?vue&type=template&id=c591d83c&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"

import "./AddBranch.vue?vue&type=style&index=0&id=c591d83c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c591d83c"

export default script